import React from 'react';
import {
    PopUpText,
    PopUpDesktopWrap,
    LogOutPopUpDiv,
} from './UserDetails.styled';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const LogoutPopUp = ({ onClose, logout }) => {
    const { t } = useTranslation();
    useEffectWithErrorLogging(() =>{
        const autoComplete = document.getElementById('equityLogout');
        if(autoComplete){
            autoComplete.style.zIndex = 0; 
        }

        return (() => {
            if(autoComplete){
                autoComplete[0].style.zIndex =10; 
            } 
        });
    },[]);
    return (
        <>
            <Popup
                onClose={onClose}
                title={t('userPanel.logoutPopup.logoutConfirmationText')}
                width={'192px'}
                webWidth={'192px'}
                textAlign={'start'}
                id={'common-equity-Logout-popup'}
            >
                <LogOutPopUpDiv divHeight={'100px'}>
                    <PopUpText />
                    <PopUpDesktopWrap flexDirection="row-reverse">
                        <Button
                        id={'common-equityLogout'}
                            show={true}
                            width={'320px'}
                            height={'38px'}
                           // primary={true}
                            variant={ButtonStyles.primary}
                            // borderRadius={'19px'}
                            margin={'5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={logout}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t('common.logoutButton')}
                            </div>
                        </Button>
                        <Button
                            show={true}
                            //secondary
                            variant={ButtonStyles.secondary}
                            width={'308px'}
                            height={'38px'}
                            // borderRadius={'19px'}
                            margin={'5px 0 5px 5px'}
                            // fontSize={'15px'}
                            // fontFamily={'AvenirNextWorld Demi'}
                            clicked={onClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>
                                {t('userPanel.logoutPopup.cancelButton')}
                            </div>
                        </Button>
                    </PopUpDesktopWrap>
                </LogOutPopUpDiv>
            </Popup>
        </>
    );
};

export default LogoutPopUp;
